const initialState = {
  information: { TOFM: "" },
  version: null,
  tax: 0,
  ADHDActive: false,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_INFORMATION":
      return {
        ...state,
        information: action.data,
        version: action.version,
        tax: action.tax,
        ADHDActive: action.ADHDActive,
      };
    default:
      return { ...state };
  }
};

export default reducer;
